<template>
    <drawer-layout>
        <main class="bible">
            <data-record-explore-header :emptyRecords="emptyRecords" :breadcrumbs-items="breadcrumbsItems" :generated="generated" @resetGenerated="resetGenerated"/>

            <data-records-table @emptyRecords="recordsAreEmpty" @generated="recordsAreSave"/>
        </main>
    </drawer-layout>
</template>

<script>
import RecordsPage from "@/Pages/DataGathering/RecordsPage";

export default {
    mixins: [ RecordsPage ],

    props: {

    },

    data: () => ({
        emptyRecords: false,
        generated: false,
    }),

    methods: {
        recordsAreEmpty() {
            this.emptyRecords = true;
        },

        //Set value from --generated-- event of data-records-table component
        recordsAreSave() {
            this.generated = true;
        },

        //Reset value to false of generated when generated event is used
        resetGenerated(){
            this.generated = false;
        },
    },

    computed: {
        breadcrumbsItems() {
            if(!this.dataGathering.id){
                return [];
            }

            return [
                {
                    text: this.$t('app.sidebar_items.data_sources'),
                    disabled: true,
                },
                {
                    text: this.$t('app.sidebar_items.finished'),
                    disabled: false,
                    href: route('finished.index'),
                },
                {
                    text: this.dataGathering.uuid.split('-').first(),
                    disabled: true,
                }
            ]
        },

    },
};
</script>

<style>

</style>
